import ImagemPerfilSefaz from 'assets/img/PerfilSefaz.svg';
import ImagemPerfilContribuinte from 'assets/img/PerfilContribuinte.svg';
import ImagemPerfilContribuinteLogado from 'assets/img/PerfilContribuinteLogado.svg';
import { ENUM_TIPO_PERFIL } from 'utils/permissao';
import { primeiraLetraPalavraUpperCase } from 'utils/funcaoPadrao';

export const getAuthorTitle = (isAtendente, apelido, setor, user) => {
  if (!isAtendente && user?.profile === ENUM_TIPO_PERFIL.CONTRIBUINTE)
    return primeiraLetraPalavraUpperCase(user?.given_name);
  if (!isAtendente) return 'Contribuinte';
  else {
    const setorFormatado = setor ? ' | Setor: '.concat(setor?.nome) : '';
    return `${apelido || 'Atendente'} ${setorFormatado}`;
  }
};

export const getAvatarImage = (isAtendente, user) => {
  if (isAtendente) {
    return ImagemPerfilSefaz;
  }
  if (user?.profile === ENUM_TIPO_PERFIL.CONTRIBUINTE) {
    return ImagemPerfilContribuinteLogado;
  }
  return ImagemPerfilContribuinte;
};
